<template>
  <b-form id="data_submit" @submit="onSubmit" >
    <div class="row">
      <div class="col-lg-12">
        <div class="alert alert-info" role="alert">
          <h5>Правила редактирования данных:</h5>
          <div style="margin-bottom: 10px">Расход можно редактировать в соответствии с датой внесения/изменения расхода в данных: <span>{{settings.expense_edit_date | formatDate}}</span></div>
          <div>Ставку можно редактировать в соответствии с датой внесения/изменения дохода в данных: <span>{{settings.revenue_edit_date | formatDate}}</span></div>
        </div>
      </div>
      <div class="col-sm-12">
        <b-form-group label="Дата"
                      label-for="title">
          <datepicker input-class="form-control"
                      class="date"
                      :language="ru"
                      v-model="form.date"
                      :disabledDates="disabledDates"
                      placeholder=""></datepicker>
        </b-form-group>
        <b-form-group label="Оффер">
          <v-select :options="options" :filterable="false"
                    v-model="form.offer_id"
                    @search="onSearch">
            <template slot="no-options">
              Введите символы...
            </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.id }}
                {{ option.title }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                ({{ option.id }})
                {{ option.title }}
              </div>
            </template>
          </v-select>
        </b-form-group>
        <b-form-group v-if="this.$currentUser.department === 'adkey'" label="Приложение">
          <b-form-select
              size="sm"
              :options="applicationOwnerOptions"
              v-model="form.application_owner"
          >
          </b-form-select>
        </b-form-group>
        <b-form-group label="ID партнёра">
          <b-form-input class="insertInput"
                        type="number"
                        v-model="form.partner_id">
          </b-form-input>
        </b-form-group>

        <div class="row">
          <div class="col-sm-6">
            <b-form-group label="Subid-1">
              <b-form-input class="insertInput"
                            type="text"
                            v-model="form.sub1">
              </b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <b-form-group label="Subid-2">
              <b-form-input class="insertInput"
                            type="text"
                            v-model="form.sub2">
              </b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <b-form-group label="Subid-3">
              <b-form-input class="insertInput"
                            type="text"
                            v-model="form.sub3">
              </b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <b-form-group label="Subid-4">
              <b-form-select
                  size="sm"
                  :options="sub4Options"
                  v-model="form.sub4"
              >
              </b-form-select>
            </b-form-group>
          </div>
        </div>

        <b-form-group label="Источник">
          <v-select :options="sourcesOptions" :filterable="false"
                    v-model="form.source_id"
                    @search="onSourcesSearch">
            <template slot="no-options">
              Введите символы...
            </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.id }}
                {{ option.title }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.title }}
              </div>
            </template>
          </v-select>
        </b-form-group>
      </div>
      <div class="col-sm-6">
        <b-form-group label="Расход">
          <b-form-input class="insertInput"
                        type="number"
                        step="any"
                        v-model="form.expense">
          </b-form-input>
          <span class=" alert-danger" v-if="isExpenseOrExpenseRateChanged && submitted && !form.expense_rate && !form.expense">Введите ставку расхода или расход</span>
          <span class=" alert-danger" v-if="isExpenseOrExpenseRateChanged && submitted && form.expense_rate && form.expense">Введите или ставку расхода, или расход</span>

        </b-form-group>
      </div>
      <div class="col-sm-6">
        <b-form-group label="Ставка расхода">
          <b-form-input class="insertInput"
                        type="number"
                        step="any"
                        v-model="form.expense_rate">
          </b-form-input>
          <span class=" alert-danger" v-if="isExpenseOrExpenseRateChanged && submitted && !form.expense_rate && !form.expense">Введите ставку расхода или расход</span>
          <span class=" alert-danger" v-if="isExpenseOrExpenseRateChanged && submitted && form.expense_rate && form.expense">Введите или ставку расхода, или расход</span>

        </b-form-group>
      </div>
      <div class="col-sm-6">
        <b-form-group label="Валюта расхода">
          <v-select :options="currency"
                    v-model="form.expense_currency">
            <span slot="no-options">Совпадений не найдено.</span>
          </v-select>
        </b-form-group>
      </div>
      <div class="col-sm-12">
        <b-form-group label="Лиды">
          <b-form-input
              type="number"
              v-model="form.leads_count">
          </b-form-input>
        </b-form-group>
      </div>
      <div class="col-sm-6">
        <b-form-group label="Ставка">
          <b-form-input class="insertInput"
                        type="number"
                        step="any"
                        v-model="form.lead_rate">
          </b-form-input>
        </b-form-group>
      </div>
      <div class="col-sm-6">
        <b-form-group label="Валюта ставки">
          <v-select :options="currency"
                    v-model="form.lead_currency">
            <span slot="no-options">Совпадений не найдено.</span>
          </v-select>
        </b-form-group>
      </div>
      <div class="col-sm-6">
        <b-form-group label="Скидка,%">
          <b-form-input
              max="100"
              type="number"
              step="any"
              v-model="form.discount">
          </b-form-input>
        </b-form-group>
      </div>
<!--      <div class="col-sm-6" style="margin-bottom: 0.5rem">-->
<!--        <b-form-group label="Тест">-->
<!--          <b-form-checkbox v-model="form.is_test"-->
<!--                           value="1"-->
<!--                           unchecked-value="0" name="check-button">-->
<!--          </b-form-checkbox>-->
<!--        </b-form-group>-->
<!--      </div>-->
      <div class="col-sm-6" style="margin-top: 2rem;">
         <b-button
            type="submit"
            class="float-right"
            variant="primary">Сохранить и выйти
         </b-button>
      </div>
    </div>
    <div class="form-errors"></div>
  </b-form>
</template>
<script>
import OffersService from '../../../services/offersDataService'
import SourcesService from '../../../services/sourcesDataService'
import Datepicker from 'vuejs-datepicker'
import DataService from '../../../services/dataDataService'
import {ru} from '../../../services/customLocaleDatepicker'
import moment from 'moment'
import dataOptionsMixin from "../mixins/dataOptionsMixin";
import SettingsService from "../../../services/settingsDataService";


export default {
  name: 'MassUpdateDataModal',
  components: {
    OffersService: OffersService,
    Datepicker: Datepicker
  },
  mixins: [dataOptionsMixin],
  filters: {
    formatDate: function (value) {
      if (value) {
        return moment(new Date(value)).locale('ru').format('D MMM YYYY')
      }
    },
  },
  data() {
    return {
      defaultDate: new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1)),
      disabledDates: {},
      ru: ru,
      currency: [],
      sourcesOptions: [],
      options: [],
      submitted: false,
      settings: {
        edit_date: null,
        revenue_edit_date: null,
        expense_edit_date: null
      },
      isExpenseOrExpenseRateChanged: false,
      form: {
        date: null,
        offer_id: '',
        application_owner: null,
        sub1: '',
        sub2: '',
        sub3: '',
        sub4: '',
        source_id: '',
        expense_rate: '',
        expense_currency: '',
        leads_count: '',
        lead_rate: '',
        lead_currency: '',
        partner_id: '',
        discount: 0,
        // is_test: 0
      }
    }
  },
  props: {
    selectedData: {},
    applicationOwnerOptions: []
  },
  methods: {
    onSubmit(evt, close) {
      evt.preventDefault();
      this.submitted = true;

      if ((this.isExpenseOrExpenseRateChanged && !this.form.expense_rate && !this.form.expense) || (this.isExpenseOrExpenseRateChanged && this.form.expense_rate && this.form.expense)) {
        evt.preventDefault();

        return;
      }

      let ids = []

      this.selectedData.forEach(function (offer) {
        ids.push(offer.id)
      })

      this.form.ids = ids

      OffersService.massUpdate(this.form)
          .then(function (data) {
            if (data.length > 0) {
              let message = '';

              data.forEach(function (item) {
                if (message == '') {
                  message = message + item
                } else {
                  message = message + ', ' + item
                }
              })

              alert('Вам не хватает доступа, чтобы обновить следующие данные: ' + message)
            } else {
              if (data.error) {
                alert('Проверьте внесенные значения ставки и расхода в соответствии с разрешенными датами внесения/изменения дохода и расхода.')
              }
              this.$bvModal.hide('leadRateEditModal')
            }
            this.submitted = false;
          }.bind(this))
    },
    getCurrency() {
      OffersService.getCurrency()
          .then(function (response) {

            this.currency = response;
          }.bind(this))
    },
    onSearch(search, loading) {
      if (!search) {

        return;
      }
      loading(true);

      let sort = {
        sortBy: 'created_at',
        sortDesc: true,
      }

      let range = {
        startDate: null,
        endDate: null
      }
      let user = null;

      OffersService.getDataSelectOffers(1, sort, search, range, user)
          .then(function (response) {
            let options = [];
            response.forEach(function (element) {
              element.label = '';
              options.push(element)
            });
            this.options = options;
            loading(false);
          }.bind(this), 350)
    },
    getMainSetting() {
      SettingsService.getMainSetting()
          .then(function (settings) {
            this.settings = settings
          }.bind(this))
    },
    onSourcesSearch(search, loading) {
      if (!search) {

        return;
      }
      loading(true);

      let sort = {
        sortBy: 'created_at',
        sortDesc: true,
      }

      let range = {
        startDate: null,
        endDate: null
      }
      let user = null;

      SourcesService.getSources(1, sort, search, range, user)
          .then(function (response) {
            let options = [];
            response.data.forEach(function (element) {
              element.label = '';
              options.push(element)
            });
            this.sourcesOptions = options;
            loading(false);
          }.bind(this), 350)
    },
  },
  watch: {
    'form.expense_rate': function (newVal, oldVal) {
      this.isExpenseOrExpenseRateChanged = newVal !== oldVal;
    },
    'form.expense': function (newVal, oldVal) {
      this.isExpenseOrExpenseRateChanged = newVal !== oldVal;
    }
  },
  beforeMount() {
    this.getCurrency();
    this.getMainSetting();

    this.disabledDates = {
      ranges: [{
        from: new Date(1970, 1, 1),
        to: new Date(this.settings.edit_date)
      }]
    }

    this.form.date = this.defaultDate >= new Date(this.settings.edit_date) ? this.defaultDate : this.settings.edit_date
  }
}
</script>
<style>
.vdp-datepicker input {
  background-color: white !important;
}
</style>



// WEBPACK FOOTER //
// resources/js/views/front/modals/MassUpdateDataModal.vue